/**
 * @class WalletBackendProvider
 */
function WalletBackendProvider() {
    let BdcUrl;

    this.setBDCUrl = function setBdcURL(url) {
        BdcUrl = url;
    };

    this.$get = [
        '$http',
        '$rootScope',
        function ($http, $rootScope) {
            let self = {};

            self.getBusinessForm = () => {
                return $http.get(BdcUrl + 'business/form').then(res => {
                    return res.data;
                });
            };

            self.getStoreBusinesses = (id) => {
                return $http.get(BdcUrl + 'businesses/' + id).then(res => {
                    return res.data;
                });
            };

            self.getBusinessById = (id) => {
                return $http.get(BdcUrl + 'business/' + id).then(function(res) {
                    return res.data;
                });
            };

            self.getAllBusinesses = (filters) => {
                let baseUrl = BdcUrl + 'businesses?limit='+ filters.limit + '&offset=' + filters.offset * filters.limit;
                baseUrl += '&rds=[' + filters.rds.join(',') + ']';
                baseUrl += '&users=[' + filters.users.concat(filters.initiateur, filters.formerRDS).join(',') + ']';
                baseUrl += '&drv=[' + filters.drv.join(',') + ']';
                if (filters.activity.length !== 0) {
                    baseUrl += '&businessActivity=[' + filters.activity.join(',') + ']';
                }

                if (filters.status !== undefined && filters.status !== null) {
                    baseUrl += '&status=[' + filters.status.join(',') + ']';
                }

                if (filters.network !== undefined && filters.network !== null) {
                    baseUrl += '&network=' + filters.network;
                }

                if (filters.identifiant !== undefined && filters.identifiant !== null) {
                    baseUrl += '&identifiant=' + filters.identifiant;
                }

                if (filters.department !== undefined && filters.department !== null) {
                    baseUrl += '&department=' + filters.department;
                }

                if (filters.client !== undefined && filters.client !== null) {
                    baseUrl += '&client=' + filters.client;
                }

                if (filters.dateStart !== undefined && filters.dateStart !== null) {
                    baseUrl += '&dateStart=' + filters.dateStart;
                }

                if (filters.dateEnd !== undefined && filters.dateEnd !== null) {
                    baseUrl += '&dateEnd=' + filters.dateEnd;
                }

                if (filters.creationDateStart !== undefined && filters.creationDateStart !== null) {
                    baseUrl += '&creationDateStart=' + filters.creationDateStart;
                }

                if (filters.creationDateEnd !== undefined && filters.creationDateEnd !== null) {
                    baseUrl += '&creationDateEnd=' + filters.creationDateEnd;
                }

                if (filters.signatureMonth[0] !== undefined && filters.signatureMonth[0] !== null) {
                    baseUrl += '&signatureMonthStart=' + filters.signatureMonth[0];
                    if (filters.signatureMonth[1] !== null) {
                        baseUrl += '&signatureMonthEnd=' + filters.signatureMonth[1];
                    }
                }

                if (filters.relanceMonth[0] !== undefined && filters.relanceMonth[0] !== null) {
                    baseUrl += '&relanceMonthStart=' + filters.relanceMonth[0];
                    if (filters.relanceMonth[1] !== null) {
                        baseUrl += '&relanceMonthEnd=' + filters.relanceMonth[1];
                    }
                }

                if (filters.businessScenario.length !== 0) {
                    baseUrl += '&businessScenario=[' + filters.businessScenario.join(',') + ']';
                }
                
                return $http.get(baseUrl).then(res => {
                    return res.data;
                });
            };

            self.createBusiness = function(data) {
                return $http.post(BdcUrl + 'business', data).then(function(res) {
                    return res.data;
                });
            };

            self.updateBusiness = function(data) {
                return $http.post(BdcUrl + 'business/' + data.businessId, data).then(function(res) {
                    return res.data;
                });
            };

            self.deleteBusiness = function(data) {
                return $http.delete(BdcUrl + 'business/' + data.businessId, data).then(function(res) {
                    return res.data;
                });
            };

            /**
             * Add a new appointment
             * @param {String} storeId
             * @param {Object} data
             * @return {Promise}
             */
            self.sendCreateWallet = (data) => {
                return $http.post(BdcUrl + 'wallet/send', data).then(function(res) {
                    return res.data;
                });
            };

            return self;
        }
    ];
}

angular.module('app.prospection.wallet.walletBackend', [])
    .provider('walletBackend', WalletBackendProvider);
